var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"margin-top-lg text-align--center signup-confirmation"},[_c('h3',[_vm._v("Thank you!")]),_c('br'),_c('md-button',{staticClass:"md-primary",attrs:{"href":_vm.appUrl}},[_c('md-icon',[_vm._v("exit_to_app")]),_vm._v("Go back to Assure+ Go App ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }